import React from 'react';
import { connect } from 'react-redux';
import {
  UxModal,
  UxModalHeader,
  UxModalBody,
  UxModalFooter
} from '@lwt-helix/core';

const ConfirmationModal = props => {
  const reset = () => {
    props.close();
  };

  return (
    <UxModal title="Permission Confirmation" isOpen={props.open} toggle={reset}>
      <UxModalHeader toggle={reset} closeAriaLabel="close">
        Permission
      </UxModalHeader>
      <UxModalBody>
        Turning off this permission will also turn off the "
        {props.permissionIdsAndNames.length > 1 
          ? props.permissionIdsAndNames.map(permissionIdAndName => permissionIdAndName.name).join('", "') + '" permissions'
          : props.permissionIdsAndNames?.[0]?.name + '" permission'}. Do you want to continue?
      </UxModalBody>
      <UxModalFooter
        primaryLabel="Turn off permissions"
        primaryAction={props.submit}
        cancelAction={reset}
      />
    </UxModal>
  );
};

const mapStateToProps = (state, ownProps) => {
  if (
    ownProps.offices !== state.roster.offices &&
    state.roster.offices != null
  ) {
    return {
      // tech debt: offices props is only used to skip the mapping when office data hasn't changed
      // Should actually use a memoized mapping function instead, but...
      offices: state.roster.offices,
      options: state.roster.offices.map(office => ({
        value: office.id,
        label: office.shortName
      }))
    };
  } else {
    return {};
  }
};

export default connect(mapStateToProps)(ConfirmationModal);
